import {apiCaller} from '@shared/api/core/api_call';

export const apiCall = apiCaller('website_backend', fetch, console.error, {
  schemaValidation: false,
});
